// External Libraries
import gql from 'graphql-tag';

export const IS_GUEST_MEMBER_BENEFITS_ELIGIBLE_QUERY = gql`
  query IsGuestMemberBenefitsEligibleQuery(
    $bank: BankAccountInput
    $billingAddress: AddressInput
    $card: CardInput
    $country: CountryCodes!
    $email: String!
    $firstName: String!
    $lastName: String!
    $phone: PhoneInput!
    $shippingAddress: AddressInput
    $token: String!
  ) {
    isGuestMemberBenefitsEligible(
      bank: $bank
      billingAddress: $billingAddress
      card: $card
      country: $country
      email: $email
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      shippingAddress: $shippingAddress
      token: $token
    ) {
      isEligible
    }
  }
`;
